<template>
  <div class="site-time">
    На Камчатке
    <span class="site-time__time">{{ currentTime }}</span>
  </div>
</template>

<script>
// utils
import { getCurrentDate } from '@/utils'

export default {
  data () {
    return {
      timer: null,
      currentTime: null
    }
  },
  created () {
    this.setTimer()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    setTimer () {
      this.timer = setInterval(() => {
        this.currentTime = getCurrentDate(Date.now(), 'kk mm')
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes blinker {
  50% { opacity: 0; }
}

.site-time {
  @include font-size(15px);
  color: $white;
  text-align: right;

  &__time {
    @include font-size(26px);
    margin-left: 3px;
    position: relative;

    &::before {
      animation: blinker 1.7s step-start infinite;
      content: ':';
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
    }
  }
}
</style>
